module.exports = __webpack_public_path__ + "static/media/material-fabric.7585aac1.svg";